import React, {useMemo} from 'react';
import {StyleSheet, css} from '../../../styleSheet';
import {BaseResponsiveLayoutProps} from '../types';
import {getResponsiveBaseStyles} from '../functions/getResponsiveBaseStyle';
import {BaseLayoutStyleCategories} from '../coreLayout';

export const BaseResponsiveLayout: React.FC<BaseResponsiveLayoutProps> = ({
  styles,
  sizeRanges,
  children,
}) => {
  const responsiveStyles = useMemo(
    () =>
      getResponsiveBaseStyles(BaseLayoutStyleCategories, styles, sizeRanges),
    [sizeRanges, styles],
  );

  const responsiveClassName = useMemo(
    () => css(StyleSheet.create({'di-resp': {...responsiveStyles}})['di-resp']),
    [responsiveStyles],
  );

  const classNameProp = useMemo(
    () => ({className: `di-div ${responsiveClassName}`}),
    [responsiveClassName],
  );

  return <div {...classNameProp}>{children}</div>;
};
